import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu'
import { type ComponentProps, type ReactElement } from 'react'
import { cn } from '@/lib/utils'

function DropdownMenu (props: ComponentProps<typeof DropdownMenuPrimitive.Root>): ReactElement {
  return <DropdownMenuPrimitive.Root {...props} />
}

function DropdownMenuTrigger (props: ComponentProps<typeof DropdownMenuPrimitive.Trigger>): ReactElement {
  return <DropdownMenuPrimitive.Trigger {...props} />
}

function DropdownMenuContent ({
  className,
  sideOffset = 6,
  ...props
}: ComponentProps<typeof DropdownMenuPrimitive.Content>): ReactElement {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
          'z-50 min-w-[10rem] overflow-hidden rounded-md border border-(--bp-border) bg-(--bp-surface) p-1 text-(--bp-ink) shadow-(--shadow-lg)',
          className
        )}
        {...props}
      />
    </DropdownMenuPrimitive.Portal>
  )
}

function DropdownMenuItem ({
  className,
  variant = 'default',
  ...props
}: ComponentProps<typeof DropdownMenuPrimitive.Item> & { variant?: 'default' | 'destructive' }): ReactElement {
  return (
    <DropdownMenuPrimitive.Item
      className={cn(
        'relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-2.5 py-1.5 text-[13px] text-(--bp-ink2) outline-none transition-colors',
        'focus:bg-(--bp-surface2) focus:text-(--bp-ink) data-disabled:pointer-events-none data-disabled:opacity-50',
        variant === 'destructive' && 'text-(--bp-critical) focus:bg-(--bp-critical-pale) focus:text-(--bp-critical)',
        className
      )}
      {...props}
    />
  )
}

function DropdownMenuSeparator ({ className, ...props }: ComponentProps<typeof DropdownMenuPrimitive.Separator>): ReactElement {
  return (
    <DropdownMenuPrimitive.Separator
      className={cn('-mx-1 my-1 h-px bg-(--bp-border)', className)}
      {...props}
    />
  )
}

export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator
}
